import React from 'react';
import classnames from 'classnames';
import { FormattedNumber } from 'react-intl';

const QuantityColumnValue = ({ value, className }) =>
  !value && value !== 0 ? null : (
    <span
      className={classnames(
        'amount',
        { 'text-muted': !value, 'text-danger': value < 0 },
        className,
      )}
    >
      <FormattedNumber value={value} maximumFractionDigits={5} />
    </span>
  );
export default QuantityColumnValue;
